import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Search from './components/Search';

const search = (props,{ t }) => (
  <Container>
    <Search  {...props} />
  </Container>
);

search.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(search);
